import { useMemo, useState } from "react";
import { createPortal } from "react-dom";
import { ModalOverlay, ModalT1 } from ".";
import { PortalFooter } from "../../molecules/Footer";
import { PortalHeader } from "../../molecules/Header";
import { ModalBodyT1 } from "./Body";
import { StyledConfirmMatch, StyledLabelForConfirm } from "./Modal.styles";

const rootModals = document.getElementById("root-modals");

export const ConfirmationModal = ({
  closeModal,
  handleModalWork,
  description,
  btnName,
  titleOfModal,
  labelForConfirmCheck,
  isLoading,
  btnVariant = "primary",
  confirmMatch,
  confirmMatchLabel = "Type the company name to confirm",
  cancelTitle = "Cancel",
  onCancel,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const [typedName, setTypedName] = useState("");
  const nameRequired = confirmMatch != null && confirmMatch !== "";

  const isDisabled = useMemo(
    () =>
      (labelForConfirmCheck && !isChecked) ||
      (nameRequired && typedName.trim() !== confirmMatch.trim()),
    [isChecked, labelForConfirmCheck, nameRequired, typedName, confirmMatch],
  );

  const modalContent = (
    <ModalOverlay aria-modal="true" role="dialog" aria-labelledby="confirmation-modal-title">
      <ModalT1 $minWidth={480} $maxWidth={600}>
        <PortalHeader title={titleOfModal} onClose={closeModal} />

        <ModalBodyT1 className="confirm-modal-msg">
          <div>{description}</div>

          {labelForConfirmCheck && (
            <ConfirmWithCheck
              description={labelForConfirmCheck}
              isChecked={isChecked}
              setIsChecked={setIsChecked}
            />
          )}
          {nameRequired && (
            <StyledConfirmMatch>
              {confirmMatchLabel}
              <input
                aria-label={confirmMatchLabel}
                value={typedName}
                onChange={event => setTypedName(event.target.value)}
              />
            </StyledConfirmMatch>
          )}
        </ModalBodyT1>

        <PortalFooter
          className="for-confirm-modal"
          isDisabled={isDisabled}
          onApply={handleModalWork}
          onCancel={onCancel ?? closeModal}
          applyTitle={btnName}
          applyVariant={btnVariant}
          cancelTitle={cancelTitle}
          isLoading={isLoading}
        />
      </ModalT1>
    </ModalOverlay>
  );

  return createPortal(modalContent, rootModals);
};

const ConfirmWithCheck = ({ description, isChecked, setIsChecked }) => {
  const handleChange = e => {
    setIsChecked(e.target.checked);
  };

  return (
    <StyledLabelForConfirm className="confirmDeletion">
      <input type="checkbox" onChange={handleChange} checked={isChecked} />
      {description}
    </StyledLabelForConfirm>
  );
};
